/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function TableInsertRowAbove({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M8.475 5.875a.6.6 0 1 1-1.2 0v-1.9h-1.9a.6.6 0 1 1 0-1.2h1.9v-1.9a.6.6 0 0 1 1.2 0v1.9h1.9a.6.6 0 1 1 0 1.2h-1.9z" /><path fill="currentColor" fillRule="evenodd" d="M14.975 13.125a2.6 2.6 0 0 1-2.6 2.6h-9a2.6 2.6 0 0 1-2.6-2.6v-5.5a.6.6 0 1 1 1.2 0v.9h11.8v-.9a.6.6 0 0 1 1.2 0zm-1.2-3.4h-11.8v3.4a1.4 1.4 0 0 0 1.4 1.4h9a1.4 1.4 0 0 0 1.4-1.4z" clipRule="evenodd" /><path fill="currentColor" d="M14.375 5.975a.6.6 0 0 0 .6-.6v-1a1.6 1.6 0 0 0-1.6-1.6h-.5a.6.6 0 0 0 0 1.2h.5c.22 0 .4.18.4.4v1a.6.6 0 0 0 .6.6M2.875 2.775a.6.6 0 1 1 0 1.2h-.5a.4.4 0 0 0-.4.4v1a.6.6 0 1 1-1.2 0v-1a1.6 1.6 0 0 1 1.6-1.6z" /></svg>;
}
;